import { PlatformSlug } from 'constants/consts'
import { getFeatureConfig, isFeatureAvailable } from 'platformConfig'
import { CommonElementTabs } from './consts'

export type CommonElementsConfig = Record<CommonElementTabs, boolean>

const ENABLED_COMMON_ELEMENTS: CommonElementsConfig = {
  [CommonElementTabs.TESTIMONIALS]: true,
  [CommonElementTabs.SCREENSHOT_REVIEWS]: true,
}

export const COMMON_ELEMENTS_CONFIG: Partial<Record<PlatformSlug, CommonElementsConfig>> = {
  [PlatformSlug.DATBooster]: ENABLED_COMMON_ELEMENTS,
  [PlatformSlug.OATBooster]: ENABLED_COMMON_ELEMENTS,
  [PlatformSlug.DATCrusher]: ENABLED_COMMON_ELEMENTS,
  [PlatformSlug.PATBooster]: ENABLED_COMMON_ELEMENTS,
  [PlatformSlug.INBDEBooster]: ENABLED_COMMON_ELEMENTS,
  [PlatformSlug.CasperBooster]: ENABLED_COMMON_ELEMENTS,
  [PlatformSlug.NBDHEBooster]: ENABLED_COMMON_ELEMENTS,
  [PlatformSlug.NDEBCrusher]: ENABLED_COMMON_ELEMENTS,
  [PlatformSlug.CARSBooster]: ENABLED_COMMON_ELEMENTS,
  [PlatformSlug.GREBooster]: ENABLED_COMMON_ELEMENTS,
  [PlatformSlug.DLOSCE]: {
    [CommonElementTabs.TESTIMONIALS]: true,
    [CommonElementTabs.SCREENSHOT_REVIEWS]: false,
  },
}

export const getCommonElementsConfig = (slug?: PlatformSlug) => getFeatureConfig(COMMON_ELEMENTS_CONFIG, slug)
export const isCommonElementsAvailable = (slug?: PlatformSlug) => isFeatureAvailable(COMMON_ELEMENTS_CONFIG, slug)
